module.exports = __webpack_public_path__ + "img/picture_news_04.83f88935.png";